// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthModule } from './modules/management/auth/auth.module';
import { LandingModule } from './modules/management/landing/landing.module';
import { FestivalModule } from './modules/management/festival/festival.module';
import { AccountModule } from './modules/management/account/account.module';
import { AdminModule } from './modules/management/admin/admin.module';
import { PurchaseModule } from './modules/management/purchase/purchase.module';

const routes: Routes = [
	{ path: 'auth', loadChildren: 'app/modules/management/auth/auth.module#AuthModule' },
	{ path: 'landing', loadChildren: 'app/modules/management/landing/landing.module#LandingModule' },
	{ path: 'festival', loadChildren: 'app/modules/management/festival/festival.module#FestivalModule' },
	{ path: '', redirectTo: 'account', pathMatch: 'full' },
	{ path: 'account', loadChildren: 'app/modules/management/account/account.module#AccountModule' },
	{ path: 'admin', loadChildren: 'app/modules/management/admin/admin.module#AdminModule' },
	{ path: 'purchase', loadChildren: 'app/modules/management/purchase/purchase.module#PurchaseModule' },
	{ path: '**', redirectTo: 'default/error/403', pathMatch: 'full' },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
